import { render, staticRenderFns } from "./ShopCard.vue?vue&type=template&id=03107861&scoped=true&"
import script from "./ShopCard.vue?vue&type=script&lang=js&"
export * from "./ShopCard.vue?vue&type=script&lang=js&"
import style0 from "./ShopCard.vue?vue&type=style&index=0&id=03107861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03107861",
  null
  
)

export default component.exports